<script setup lang="ts"></script>

<template>
  <div class="rounded-lg border border-zinc-200 bg-zinc-50 px-4 py-3">
    <slot />
  </div>
</template>
